"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 29"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#979797",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43 26.702l9.16-14.044 5.086 7.532-4.119 6.512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.43 26.702L26.992 7.44 40 26.702z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  })));
}

var MemoSvgNoImage = /*#__PURE__*/React.memo(SvgNoImage);
var _default = MemoSvgNoImage;
exports["default"] = _default;